module.exports = __webpack_public_path__ + "media/images/country-flags-europe-flag-russia-ru-634bb038c0faae930570531884b47632.svg";